import React from 'react'
import { TreatmentUpsellDetails } from '@customTypes/TreatmentUpsellDetails'
import { findTreatmentInCategorizedTreatments } from 'src/helpers/treatment'
import useCategorizedTreatments from '@hooks/useCategorizedTreatments'
import useStyles from './styles'
import Plus from '@components/icons/Plus'
import { TreatmentTile } from './TreatmentTile'
import { useSmartTranslation } from '@hooks/useSmartTranslation'

interface TreatmentTileProps {
  upsellDetails: TreatmentUpsellDetails
}

export const TreatmentTiles = ({ upsellDetails }: TreatmentTileProps) => {
  const { data } = useCategorizedTreatments()
  const classes = useStyles()
  const { t } = useSmartTranslation()
  const { treatmentBundleToBeUpsoldFromReferenceId, treatmentBundleToBeUpsoldTo, iconKey, nameKey, iconBadgeKey } =
    upsellDetails
  const originalTreatment = findTreatmentInCategorizedTreatments(data || [], treatmentBundleToBeUpsoldFromReferenceId)
  const upsellTreatment = findTreatmentInCategorizedTreatments(data || [], treatmentBundleToBeUpsoldTo.referenceId)

  if (!originalTreatment || !upsellTreatment) {
    return null
  }

  const upsellTreatmentIconUrl = iconKey ? t(iconKey) : upsellTreatment.iconUrl
  const upsellTreatmentNameKey = nameKey || upsellTreatment.titleKey

  const badge = iconBadgeKey ? t(iconBadgeKey) : null

  return (
    <div className={classes.tilesContainer}>
      <TreatmentTile iconUrl={originalTreatment.iconUrl} titleKey={originalTreatment.titleKey} />
      <Plus className={classes.plusIcon} />
      <TreatmentTile
        iconUrl={upsellTreatmentIconUrl}
        titleKey={upsellTreatmentNameKey}
        addDisclaimer
        badge={badge}
        removeFilter={!!iconKey}
      />
    </div>
  )
}
